export type Cleanup = () => unknown;

export class GarbageCollector {
  private _cleanups: Cleanup[] = [];

  constructor(cleanup?: Cleanup | Cleanup[]) {
    if (cleanup) this.add(cleanup);
  }

  add = (cleanup: Cleanup | Cleanup[]) => {
    this._cleanups.push(...(Array.isArray(cleanup) ? cleanup : [cleanup]));
  };

  cleanup = () => {
    this._cleanups.forEach(cleanup => cleanup());
    this._cleanups = [];
  };
}
